module.exports = __webpack_public_path__ + "static/media/staff_mastery.3875431c.png";